<div class="mt-5" [formGroup]="formGroup">
  <div class="flex flex-row justify-between items-center mb-5">
    <span
      *ngIf="fields.displayName != 'w'"
      class="text-sm font-medium card-title"
      [ngClass]="{ required: fields.isRequired }"
      >{{ fields.displayName }}</span
    >
    <div *ngIf="fields.fieldType === 'multiSelect' && !isLoading && fieldsData && fieldsData.length > 0" class="flex items-center gap-2">
      <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">Select All</span>
      <div class="switch switch-sm">
        <input
          type="checkbox"
          [checked]="isAllSelected()"
          (change)="toggleSelectAll($event)"
        />
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5" *ngIf="isLoading">
    <div
      *ngFor="let i of skeletonArray"
      class="flex items-center justify-between p-4 border rounded-xl bg-white dark:bg-coal-700"
    >
      <div class="flex items-center gap-4">
        <div
          class="w-10 h-10 rounded-full shimmer-item bg-gray-300 dark:bg-coal-700"
        ></div>
        <div
          class="w-48 h-4 rounded shimmer-item bg-gray-300 dark:bg-coal-700"
        ></div>
      </div>

      <div
        class="w-10 h-5 rounded-full shimmer-item bg-gray-300 dark:bg-coal-700"
      ></div>
    </div>
  </div>

  <div
    *ngIf="!isLoading"
    class="grid gap-5"
    [ngClass]="
      nodeId == '69f23e3b29ac20901e695233'
        ? 'grid-cols-1'
        : 'grid-cols-1 sm:grid-cols-2'
    "
  >
    <div
      class="rounded-xl border p-3 flex items-center justify-between gap-2.5 hover:bg-secondary-active"
      [ngClass]="{
        'border-blue-500 bg-blue-50':
          formGroup.get(fields.fieldName)?.value === item._id,
      }"
      *ngFor="let item of fieldsData"
    >
      <div class="flex items-center gap-3.5">
        <div class="relative size-[47px] shrink-0">
          <div class="left-2/4 top-2/4" *ngIf="item.iconUrl">
            <img [src]="item.iconUrl" class="h-50px w-50px" />
          </div>
          <div class="left-2/4 top-2/4" *ngIf="item.avatarurl">
            <img [src]="item.avatarurl" class="h-50px w-50px" />
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <span
            *ngIf="item.name"
            class="flex items-center gap-1.5 leading-none font-semibold text-sm text-gray-900"
          >
            {{ item.name }}
          </span>
          <span class="text-2sm text-gray-600 text-wraps" *ngIf="item.subText">
            {{ item.subText }}
          </span>
          <span class="text-2sm text-gray-600 text-wraps" *ngIf="item.url">
            {{ item.url }}
          </span>
        </div>
      </div>

      <div class="switch switch-sm" *ngIf="fields.fieldType == 'multiSelect'">
        <input
          name="param"
          type="checkbox"
          [checked]="isSelected(item)"
          (change)="onToggle($event, item._id)"
        />
      </div>
      <div class="switch switch-sm" *ngIf="fields.fieldType == 'radio'">
        <input
          class="radio cursor-pointer"
          [formControlName]="fields.fieldName"
          type="radio"
          (change)="onToggle($event, item.cloudId)"
          [value]="item.cloudId"
        />
      </div>
    </div>
  </div>
</div>
<div *ngIf="showValidationError" class="text-sm text-danger mt-2">
  Please select an option.
</div>
